<template>
  <div class="switch-tw inline-flex items-center cursor-pointer">
    <span class="ml-3 mr-3 text-sm font-medium" :style="{ 'color': !active ? color : 'lightgray' }" v-if="options && options.length > 1">{{options[0]}}</span>
    <label class="relative inline-flex items-center cursor-pointer">
      <input type="checkbox" @click="toggle" value="1" class="sr-only peer" :checked='active ? "checked" : ""'>
      <div class="w-11 h-6 bg-[#0157FF] peer-focus:outline-none rounded-full peer dark:bg-[#0157FF] peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#0157FF]"></div>
      <span class="ml-3 text-sm font-medium" :style="{ 'color': active ? color : 'lightgray' }">{{options.length > 1 ? options[1] : options[0]}}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'switch-tw',
  model: {
    prop: 'isEnabled',
    event: 'toggle',
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: '#0157FF',
    },
  },
  methods: {
    toggle: function () {
      this.$emit('toggle', !this.active);
    },
  },
};
</script>

